import PropTypes from 'prop-types';
import React from 'react';
import {Header, Icon} from 'semantic-ui-react';
import styled from 'styled-components';
import {withRouter} from 'react-router';
import UserProfileForm from '../../components/Form/UserProfileForm';
import {BlueContainer} from '../../components/Container/ContainerMix';
import MenuButton from '../../components/Button/MenuButton';

const FullHeightBlueContainer = styled(BlueContainer)`
  height: calc(100vh);
  overflow-y: auto;
`;

const UserProfile = ({onClickSidebar, router}) => (
  <FullHeightBlueContainer>
    <MenuButton onClick={onClickSidebar}/>
    <Header as="h2" icon textAlign="center">
      <Icon name="users" circular/>
      <Header.Content>User Profile</Header.Content>
    </Header>
    <UserProfileForm isUpdate onCancel={() => router.push('/dashboard')}/>
  </FullHeightBlueContainer>
);

UserProfile.propTypes = {
  router: PropTypes.object.isRequired,
  onClickSidebar: PropTypes.func.isRequired
};

export default withRouter(UserProfile);



// WEBPACK FOOTER //
// ./src/pages/Profile/UserProfile.js